import NonFullWidthWrapper from '@/components/NonFullWidthWrapper'
import RichText from '@/components/RichText'
import SyllabusListing from '@/components/syllabus-table/SyllabusListing'
import { CommonCopyUrlWrapper } from '@/components/ui/copy-to-clipboard/CommonCopyUrlWrapper'
import UnknownComponent from '@/components/UnknownComponent'
import { useCleanPathDefault } from '@/hooks/useCleanPathDefault'
import { WebUiSyllabusTile } from '@/kontent/content-types'
import type { WpStagegroup as WpStageGroupModel } from '@/kontent/content-types/wp_stagegroup'
import { TaxoKeyLearningArea } from '@/kontent/taxonomies'
import type { CommonPageProps, TaxoStageGroupWithLifeSkill } from '@/types'
import { ElementModels, Responses } from '@kontent-ai/delivery-sdk'
import { Fragment } from 'react'

function WpStageGroup(
	props: CommonPageProps<WpStageGroupModel> & {
		data: {
			syllabusTiles: Responses.IListContentItemsResponse<WebUiSyllabusTile>
			keyLearningAreasOptions: ElementModels.TaxonomyTerm<TaxoKeyLearningArea>[]
			stageGroups: ElementModels.TaxonomyTerm<TaxoStageGroupWithLifeSkill>[]
		}
	},
) {
	const currentUrl = useCleanPathDefault()
	const {
		pageResponse,
		syllabusTiles,
		keyLearningAreasOptions,
		stageGroups,
	} = props.data
	const page = pageResponse.item

	if (!page) {
		return (
			<UnknownComponent>
				Page {page.system.codename} does not have any content!
			</UnknownComponent>
		)
	}

	return (
		<Fragment key={page.system.id}>
			{page.elements.title.value && (
				<CommonCopyUrlWrapper url={currentUrl} className="mb-8">
					<h1
						data-kontent-item-id={page.system.id}
						data-kontent-element-codename="title"
					>
						{page.elements.title.value}
					</h1>
				</CommonCopyUrlWrapper>
			)}
			<NonFullWidthWrapper>
				<RichText
					className="w-full"
					mappings={props.mappings}
					linkedItems={pageResponse.linkedItems}
					richTextElement={page.elements.web_content_rtb__content}
				/>
			</NonFullWidthWrapper>
			<SyllabusListing
				items={syllabusTiles.items}
				linkedItems={syllabusTiles.linkedItems}
				mappings={props.mappings}
				stageFilterData={stageGroups}
				keyLearningAreasOptions={keyLearningAreasOptions}
			/>
		</Fragment>
	)
}

export default WpStageGroup
